"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_crud_client_1 = require("./new.crud.client");
class TeamClient extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.urlTemplate = '/v1/teams';
    }
    getUsersByTeam(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { teamId } = request, params = __rest(request, ["teamId"]);
            const response = yield this.httpGet(`/v1/teams/${teamId}/users?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    getProjectsByTeam(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { teamId } = request, params = __rest(request, ["teamId"]);
            const response = yield this.httpGet(`/v1/teams/${teamId}/projects?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    removeUser(teamId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/teams/${teamId}/users/${userId}`);
        });
    }
    removeProject(teamId, projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/teams/${teamId}/projects/${projectId}`);
        });
    }
    getTeamsByProjectId(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/teams/projects/${projectId}`);
            return response.payload;
        });
    }
}
exports.TeamClient = TeamClient;
//# sourceMappingURL=team.client.js.map